import React, { useEffect, useState } from "react";
import Footer from "../../CoreComponents/Footer";
import Header from "../../CoreComponents/Header";
import MainHeader from "../../CoreComponents/MainHeader";
import NavBar from "../../CoreComponents/NavBar";
import {
  showMessage,
  getToken,
  GetDeliveryBoys,
} from "../../Functionalities/Functions";
import image from "../../Assets/images/profile_icon.jpg";
import axios from "axios";
import FilterComponent from "../../CoreComponents/FilterComponent";
import { is_accountant_only } from "../../Functionalities/Config";
import FilterModalComponent from "../../CoreComponents/FilterModalComponent";
import { protocol } from "../../Functionalities/Config";
import LoadingComponent from "../../CoreComponents/LoadingComponent"
import NoDataComponent from "../../CoreComponents/NoDataComponent";

function Body() {
  const [data, setData] = useState({ id: "", name: "", data: [] });
  const [next, setNext] = useState("");
  const [prev, setPrev] = useState("");
  const [loading, setLoading] = useState(true)
  const [filter, setfilter] = useState({
    search_text: "",
    is_approved: "",
    is_blocked: "",
  });
  // useEffect(() => {
  //   isFilterApplied &&
  //     getData();
  //   setisFilterApplied(false)
    
  // }, [isFilterApplied]);

  useEffect(() => {
    getData();

  }, []);
  

  // useEffect(() => {
  //   if (localStorage.getItem('deliboy_filter')) {
  //     setfilter(JSON.parse(localStorage.getItem('deliboy_filter')))
  //     setisFilterApplied(true)
  //   }
  //   else {
  //     setfilter({
  //       ...filter, search_text: "",
  //       is_approved: "",
  //       is_blocked: ""
  //     })

  //   }
  // }, [])




  let params =
    // "keyword=all_profile&is_deliveryboy=1" +
    // "&is_approved=" +
    // filter.is_approved +
    "&is_blocked=" +
    filter.is_blocked +
    "&search_text=" +
    filter.search_text;

  const getData = () => {

    // showMessage("Loading delivery boys", "info", "Loading", "bottom", "bottom-left", 0);

    let result = GetDeliveryBoys("", "get", "", params);
    result.then((result) => {

      setData({
        ...data,
        data: result.data.results,
        count: result.data.count,
      });
      setLoading(false)
      setNext(result.data.next);
      setPrev(result.data.previous);
    })
      .catch((err) => {
        showMessage(
          "Loading failed",
          "danger",
          "Loading error",
          "top",
          "top-right",
          0
        );
        // void 0
      });
  };

  const handlePrev = () => {
    // alert("prev");
    var config = {
      method: "get",
      url: prev.replace("http:", protocol.replace('//', "")),
      headers: {
        Authorization: getToken(),
      },
    };
    // void 0

    axios(config)
      .then(function (response) {
        // void 0
        setData({
          ...data,
          data: response.data.results,
          count: response.data.count,
        });
        setNext(response.data.next);
        setPrev(response.data.previous);
      })
      .catch(function (error) {
        // void 0
      });
  };

  const handleNext = () => {
    //alert("next")
    var config = {
      method: "get",
      url: next.replace("http:", protocol.replace('//', "")),
      headers: {
        Authorization: getToken(),
      },
    };

    axios(config)
      .then(function (response) {
        // void 0
        setData({
          ...data,
          data: response.data.results,
          count: response.data.count,
        });
        setNext(response.data.next);
        setPrev(response.data.previous);
      })
      .catch(function (error) {
        // void 0
      });
  };

  return (
    <div className="content-body" style={{ minHeight: 1100 }}>
      {
        !loading ?
          <div className="container-fluid">



            <FilterComponent
              handleNext={handleNext}
              handlePrev={handlePrev}
              next={next}
              prev={prev}
              count={data.count}
              addItemName={is_accountant_only ? undefined : "Add Delivery Boys"}
              addItemPath={is_accountant_only ? undefined : "/addboy"}
              filterButtonName={"Filter"}
            />

            <FilterModalComponent
              heading={"Filter Delivery Boys"}
              searchItemValue={filter.search_text}
              name={"boy"}
              searchItemChange={(e) =>
                setfilter({
                  ...filter,
                  search_text: e.target.value,
                })
              }
              clearFilter={(e) => {
                e.preventDefault();
                window.location.reload();
                localStorage.removeItem('deliboy_filter')
                setfilter({
                  ...filter, search_text: "",
                  is_approved: "",
                  is_blocked: "",
                })
              }}
              submitFilter={(e) => {
                e.preventDefault();
                getData();
                localStorage.setItem('deliboy_filter', JSON.stringify(filter))
              }}
            >
              {/* <div className="col-lg-6">
                <div className="form-group">
                  <label className="text-black font-w600">
                    Approved <span className="required"></span>
                  </label>
                  <select
                    value={filter.is_approved}
                    class="form-control form-control-lg  "
                    onChange={(e) =>
                      setfilter({
                        ...filter,
                        is_approved: e.target.value,
                      })
                    }
                  >

                    <option value={""} id={""}>
                      All
                </option>
                    <option value={"true"} id={"true"}>
                      Yes
                </option>
                    <option value={"false"} id={"false"}>
                      No
                </option>
                  </select>
                </div>
              </div> */}
              <div className="col-lg-6">
                <div className="form-group">
                  <label className="text-black font-w600">
                    Blocked <span className="required"></span>
                  </label>
                  <select
                    value={filter.is_blocked}
                    class="form-control form-control-lg  "
                    onChange={(e) =>
                      setfilter({
                        ...filter,
                        is_blocked: e.target.value,
                      })
                    }
                  >
                    <option value={""} id={""}>
                      All
                    </option>
                    <option value={"true"} id={"true"}>
                      Yes
                    </option>
                    <option value={"false"} id={"false"}>
                      No
                    </option>
                  </select>
                </div>
              </div>
            </FilterModalComponent>

            <div className="row">
              <div className="col-lg-12">
                <div className="table-responsive rounded card-table">
                  <div id="example5_wrapper" class="dataTables_wrapper no-footer">
                    <table className="table border-no order-table mb-4 table-responsive-lg dataTablesCard" id="example5" >
                      <thead>
                        <tr>
                          <th>ID</th>
                          <th>NAME</th>
                          <th>TO GET</th>
                          <th>TO PAY</th>
                          {/* <th>Email</th> */}
                          <th>ADDRESS</th>
                          <th>BLOCKED</th>
                          {/* <th>APPROVED</th> */}
                          {/* <th>Action</th> */}
                        </tr>
                      </thead>
                      <tbody>
                        {data.data.length > 0
                          ?
                          data.data.map((item, index) => {
                            return (
                              <tr>
                                {/*  <tr style={{ cursor: "pointer" }} onClick={() => window.location.replace(`/deliboy/` + item.id)}> */}
                                <td>
                                  {/* <a href={`/deliboy/` + item.id}> */}
                                  <a href={`/deliboy/${item.id} `}><h5 className="mb-0 fs--1">FDRDLBY{item.id}</h5></a>
                                </td><a href={`/deliboy/` + item.id}>
                                  <td>
                                    <div className="d-flex align-items-center">
                                      <img className="mr-3 img-fluid btn-rounded" width={30} src={image} alt="Foodoor" />
                                      <span className="w-space-no">{item.first_name}<br />{item.details && item.details.mobile}</span>
                                    </div>
                                    {item.deliveryboy_rating && (
                                      <div class="star-review2 d-flex align-items-center flex-wrap fs-12 mt-2 ml-5">

                                        <div class="mb-2">
                                          <i class="fa fa-star text-primary">&nbsp;{item.deliveryboy_rating.toFixed(1)}</i>
                                        </div>
                                      </div>
                                    )}
                                  </td>
                                </a>

                                <td>
                                  <a
                                    href={`/deliboy/` + item.id}
                                    className="badge badge-md "

                                  >
                                    <span class="btn-icon-left text-warning">
                                      <i class="fa fa-download color-warning"></i>
                                      &nbsp;{item.balance.balance}
                                    </span>
                                    {/* <span class="btn-icon-left text-warning">
                                      <i class="fa fa-download color-warning"></i>
                                      &nbsp;{item.balance.collected}
                                    </span>
                                    <span class="btn-icon-left text-warning">
                                      <i class="fa fa-download color-warning"></i>
                                      &nbsp;{item.balance.submitted}
                                    </span> */}
                                  </a>
                                </td>
                                <td>
                                  <a
                                    href={`/deliboy/` + item.id}
                                    className="badge badge-md "

                                  >
                                    <span class="btn-icon-left text-success">
                                      <i class="fa fa-upload color-success"></i>
                                      &nbsp;{item.delivery_charge_balance.balance}
                                    </span>
                                    {/* <span class="btn-icon-left text-success">
                                      <i class="fa fa-upload color-success"></i>
                                      &nbsp;{item.delivery_charge_balance.delivery_charge}
                                    </span>
                                    <span class="btn-icon-left text-success">
                                      <i class="fa fa-upload color-success"></i>
                                      &nbsp;{item.delivery_charge_balance.delivery_tip}
                                    </span>
                                    <span class="btn-icon-left text-success">
                                      <i class="fa fa-upload color-success"></i>
                                      &nbsp;{item.delivery_charge_balance.incentive}
                                    </span>
                                    <span class="btn-icon-left text-success">
                                      <i class="fa fa-upload color-success"></i>
                                      &nbsp;{item.delivery_charge_balance.paid_delivery_charge}
                                    </span> */}
                                  </a>
                                </td>

                                <div className="modal fade" id="sendMessageModal" aria-hidden="true" style={{ display: "none" }}>
                                  <div className="modal-dialog modal-dialog-centered" role="document" >
                                    <div className="modal-content">
                                      <div className="modal-header">
                                        <h5 className="modal-title">Delivery Checkouts</h5>
                                        <button type="button" className="close" data-dismiss="modal"><span>×</span></button>
                                      </div>
                                      <div className="modal-body">
                                        <form className="comment-form">
                                          <div className="row">
                                            <div className="col-lg-6">
                                              <div className="form-group">
                                                <label className="text-black font-w600"> Amount to clear{" "}<span className="required">*</span></label>
                                                <input type="text" className="form-control" placeholder="123" readOnly />
                                              </div>
                                            </div>
                                            <div className="col-lg-6">
                                              <div className="form-group">
                                                <label className="text-black font-w600">
                                                  Cleared amount{" "}
                                                  <span className="required">
                                                    *
                                                  </span>
                                                </label>
                                                <input
                                                  type="text"
                                                  className="form-control"
                                                  placeholder="amt"
                                                />
                                              </div>
                                            </div>
                                            <div className="col-lg-12">
                                              <div className="form-group">
                                                <label className="text-black font-w60">
                                                  Description
                                                </label>
                                                <textarea
                                                  rows={8}
                                                  className="form-control"
                                                  placeholder="description"
                                                />
                                              </div>
                                            </div>
                                            <div className="col-lg-12">
                                              <div className="form-group mb-0">
                                                <input
                                                  type="submit"
                                                  defaultValue="Post Comment"
                                                  className="submit btn btn-primary"
                                                  name="submit"
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        </form>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <td>
                                  <a href={`/deliboy/` + item.id} >
                                    {typeof item.address != "undefined" &&

                                      item.address != null &&
                                      item.address.length != null &&
                                      item.address.length > 0 ? (
                                      <div>{item.address[0].address1} </div>
                                    ) : (
                                      <div> No Address</div>
                                    )}

                                  </a>


                                </td>
                                <td>
                                  <a href={`/deliboy/` + item.id}>
                                    <div className="d-flex align-items-center">
                                      {item.is_blocked === false ? (
                                        <>
                                          <i className="fa fa-circle text-danger mr-1 " />{" "}
                                          NO
                                        </>
                                      ) : (
                                        <>
                                          <i className="fa fa-circle text-success mr-1 " />{" "}
                                          YES
                                        </>
                                      )}
                                    </div>
                                  </a>


                                </td>
                                {/* <td>
                                <a href={`/deliboy/` + item.id}>
                                  <div className="d-flex align-items-center">
                                    {item.details.is_approved === false ? (
                                      <>
                                        <i className="fa fa-circle text-danger mr-1 " />{" "}
                                        NO
                                      </>
                                    ) : (
                                      <>
                                        <i className="fa fa-circle text-success mr-1 " />{" "}
                                        YES

                                      </>
                                    )}
                                  </div>
                                </a>

                              </td> */}

                              </tr>

                            );
                          })
                          : <NoDataComponent data="Delivery boys " />}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          : <LoadingComponent />
      }
    </div>

  );
}

function DeliveryBoys() {
  return (
    <div>
      <div id="main-wrapper">
        <MainHeader />
        <Header
          name={"Delivery Boys"}
          subHeading={"All delivery boys under foodoor"}
        />

        <NavBar />

        <Body />
        <Footer />
      </div>
    </div>
  );
}

export default DeliveryBoys;
